import { EditSignatureContext } from "./editSignature";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { Button, ButtonProps } from "../core/components/button";
import { ReportMetaDataHelper } from "./reportMetaDataHelper";
import { Helper } from "../core/util/helper";
import { RoleViewModel } from "./signatureGrid";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";
export default class RoleDropDown extends React.Component<RoleDropDownProps, RoleDropDownState>{
    private factory = ComponentHelper.createFactory();
    constructor(props: RoleDropDownProps) {
        super(props);
        this.state = {
            roles: props.context.dataSources.roles,
            value: props.value
        }
    }

    private setValue = (dataItem: RoleViewModel) => {
        this.setState({ value: dataItem.Key }, () => { this.props.onChange(this.props.field, dataItem.Key, dataItem) });
    }

    private expendsRoles = (data: RoleViewModel) => {
        let roles = this.state.roles;
        roles.push(data);
        this.setState({ roles: roles }, () => { this.setValue(data) })
    }

    private createDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = JSON.parse(JSON.stringify(this.state.roles));
        props.disabled = this.props.disabled;
        props.value = this.state.value;
        props.field.dataValueField = "Key";
        props.field.dataTextField = "Value";
        props.field.refreshDSOnRefChange = true;
        props.onChange = (field, value, dataItem) => {
            this.setValue(dataItem);
        }
        return (<div style={{ flexGrow: 100, marginRight: "5px" }}><DropDownList {...props} /></div>);
    }

    private createButton = () => {
        let props: ButtonProps = {
            handleClick: this.addNew,
            iconName: "plus"
        }
        return (<><Button {...props}/></>);
    }

    private addNew = () => {
        ReportMetaDataHelper.createNewRole().then((data: RoleViewModel) => {
            if (Helper.hasValue(data))
                this.expendsRoles(data);
        });
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center" }}>
                {!this.props.disabled ? this.createButton() : null}
                {this.createDropDown()}
            </div>
        );
    }

}

interface RoleDropDownProps {
    context: EditSignatureContext;
    value: number;
    onChange: (field: any, value: number, dataItem: RoleViewModel) => void;
    field: any;
    disabled: boolean;
}

interface RoleDropDownState {
    roles: KeyValuePair<number, string>[];
    value: number;
}